import { ellipsis, stripUnit } from 'polished'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { mobileCSS, tabletCSS, desktopCSS } from '@measures/responsive'
import { useFullScreenGallery } from '@hooks/useFullScreenGallery'

const Wrapper = styled.div<{ isFullScreen: boolean; isSingleSlide: boolean }>`
  ${({
    theme: {
      measures: {
        content: { paddingLeft, paddingRight, paddingTablet },
      },
      colors: { white },
    },
    isFullScreen,
    isSingleSlide,
  }) => {
    const desktopPaddingLeftDefault = Number(stripUnit(paddingLeft)) / 2
    const tabletPaddingLeftDefault = Number(stripUnit(paddingTablet)) / 2

    return css`
      ${desktopCSS(css`
        padding-top: 10px;
        padding-left: ${desktopPaddingLeftDefault}px;
        padding-right: ${paddingRight};
        ${!isFullScreen &&
        !isSingleSlide &&
        css`
          box-sizing: border-box;
          min-height: 86px;
        `}
      `)}

      ${tabletCSS(css`
        padding-top: 10px;
        padding-left: ${tabletPaddingLeftDefault}px;
        padding-right: ${paddingTablet};
        ${isFullScreen &&
        css`
          width: 100%;
          padding: 20px;
        `}
        ${!isFullScreen &&
        !isSingleSlide &&
        css`
          box-sizing: border-box;
          min-height: 86px;
        `}
      `)}

      ${mobileCSS(css`
        ${isFullScreen &&
        css`
          color: ${white};
          min-width: 0;
          padding-right: 20px;
          z-index: 2;
        `}
      `)}
    `
  }}
`

const CaptionText = styled.div<{
  isFullScreen: boolean
  isSingleSlide: boolean
}>`
  ${({
    theme: {
      measures: {
        spacing: { horizontalMobile },
      },
      colors: {
        white,
        grey: { grey_100 },
      },
    },
    isSingleSlide,
    isFullScreen,
  }) => css`
    color: ${grey_100};
    font-size: 15px;
    line-height: 1.5;

    ${desktopCSS(css`
      ${!isSingleSlide && ellipsis('100%', 3)};
      ${isFullScreen && ellipsis('100%', 3)};
    `)}

    ${tabletCSS(css`
      ${!isSingleSlide && ellipsis('100%', 3)};
      ${isFullScreen && ellipsis('100%', 3)};
    `)}

    ${mobileCSS(css`
      padding-top: ${horizontalMobile};
      ${isFullScreen
        ? css`
            color: ${white};
          `
        : css`
            padding-left: 12px;
            padding-right: 12px;
            ${!isSingleSlide && ellipsis('100%', 2)};
          `}
    `)}
  `}
`

interface CaptionProps {
  children: string
  isSingleSlide?: boolean
}

const Caption: FunctionComponent<CaptionProps> = ({
  children,
  isSingleSlide,
}) => {
  const { isFullScreen } = useFullScreenGallery()

  return (
    <Wrapper isFullScreen={isFullScreen} isSingleSlide={!!isSingleSlide}>
      <CaptionText isFullScreen={isFullScreen} isSingleSlide={!!isSingleSlide}>
        {children}
      </CaptionText>
    </Wrapper>
  )
}

export default Caption
